import React, { useEffect, useMemo, useState } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as CheckIcon } from '../images/check-icon.svg'
import { ReactComponent as KycIcon } from '../images/kyc.svg'
import { ReactComponent as BankIcon } from '../images/bank.svg'
import { ReactComponent as MoneyIcon } from '../images/money-bag.svg'
//import { ReactComponent as LockIcon } from '../images/lock.svg'
import { ReactComponent as UserIcon } from '../images/user.svg'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetLocLimitMutation, useUnlockLocLimitMutation } from '../lib/services/eligibilityApi';
import { generateChecksum } from '../lib/middleware/generateChecksum';
import PageHeader from '../components/PageHeader';
import { setLocDetails, setPageError, setRedirection } from '../lib/features/eligibilitySlice';
import { useDispatch, useSelector } from 'react-redux';
import CenteredPopup from '../components/popups/CenteredPopup';
import { formatCurrency } from '../lib/middleware/currencyFormatter';
function CreditApproval() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [getLocLimit] = useGetLocLimitMutation();
    const [unlockLocLimit, { isLoading }] = useUnlockLocLimitMutation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { pageerror, locDetails } = useSelector((state) => state.eligibility);
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const handleOpen = () => {
        setIsModalOpen(true);
    }
    const handleClose = () => {
        setIsModalOpen(false);
        dispatch(setPageError(''))
    }
    const modalButtons = [
        { label: 'Close', onClick: handleClose }
    ]

    useEffect(() => {
        const fetchLocLimit = async () => {
            try {
                let jwt_token
                if (jwt) {
                    jwt_token = jwt
                    localStorage.setItem('jwt', jwt)
                } else {
                    jwt_token = localStorage.getItem('jwt')
                }
                const checksum = generateChecksum({ mode: 'get_loc_limit' })
                const scrt = secret ? secret : localStorage.getItem('secret')
                const result = await getLocLimit({ jwt_token, checksum, scrt })
                if ((result.data && result.data.status === 'error') || (result && result.status === 'error')) {
                    dispatch(setPageError(result.data.message))
                    handleOpen()
                    if (result.data.message === 'Login expired! Please re-login.') {
                        localStorage.removeItem('jwt');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    }
                } else if (result.data && result.data.http_code === 201) {
                    handleOpen()
                    dispatch(setPageError(result.data.message))
                    if (result.data.message === 'Login expired! Please re-login.') {
                        localStorage.removeItem('jwt');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    } else {
                        if (result && result.data && result.data.redirect_url) {
                            dispatch(setRedirection(result.data.redirect_url))
                        }
                    }
                } else if (result.error) {
                    if (result.error && result.error.data && result.error.data.message) {
                        dispatch(setPageError(result.error.data.message))
                    } else {
                        dispatch(setPageError('Please check your internet or try again later.'))
                    }
                    handleOpen()
                } else {
                    dispatch(setLocDetails({ ...result.data }))
                    if (result && result.data && result.data.redirect_url) {
                        dispatch(setRedirection(result.data.redirect_url))
                    }
                }
            } catch (error) {
                dispatch(setPageError('Something went wrong. Please try again later.'));
                handleOpen()
            }
        }
        fetchLocLimit()
    }, [getLocLimit, dispatch, jwt, navigate, secret])

    const handleUnlockLocLimit = async () => {
        try {
            let jwt_token
            if (jwt) {
                jwt_token = jwt
                localStorage.setItem('jwt', jwt)
            } else {
                jwt_token = localStorage.getItem('jwt')
            }
            const scrt = secret ? secret : localStorage.getItem('secret')
            const result = await unlockLocLimit({ jwt_token, scrt })
            if ((result.data && result.data.status === 'error') || (result && result.status === 'error')) {
                dispatch(setPageError(result.data.message))
                handleOpen()
                if (result.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                }
            } else if (result.data && result.data.http_code === 201) {
                handleOpen()
                dispatch(setPageError(result.data.message))
                if (result.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                } else {
                    if (result && result.data && result.data.redirect_url) {
                        dispatch(setRedirection(result.data.redirect_url))
                    }
                }
            } else if (result.error) {
                dispatch(setPageError('Please check your internet or try again later.'))
                handleOpen()
            } else {
                if (result && result.data && result.data.redirect_url) {
                    window.location.href = result.data.redirect_url
                }
            }
        } catch (error) {
            dispatch(setPageError('Something went wrong. Please try again later.'));
            handleOpen()
        }
    }
    return (
        <div className='external-wrapper'>
            <CenteredPopup
                isOpen={isModalOpen}
                buttons={modalButtons}
                onClose={handleClose} icon={<WarningIcon />}>
                <p>{pageerror}</p>
            </CenteredPopup>
            <div className='page-content approval-page'>
                <PageHeader />

                <div className="approval-content">
                    <div className="approval-card">
                        <div className="icon-check">
                            <CheckIcon />
                        </div>
                        <h2>Congratulations!</h2>
                        <p>You are eligible for a Personal Loan</p>
                        <h1 className="amount">₹{locDetails && locDetails.approved_loc_limit ? formatCurrency(Number(locDetails.approved_loc_limit)) : '0'}</h1>
                        <p className="note">*Subject to bank statement analysis and document approvals</p>
                    </div>

                    <div className="unlock-info">
                        {/*<div className='lock-icon'><LockIcon /></div>*/}
                        <h2 className="unlock-text">Get funds in your account in a few minutes.</h2>
                        <h2>All you need to do:</h2>
                        <div className="steps">
                            <div className="step">
                                <KycIcon />
                                <p>Complete your KYC</p>
                            </div>
                            <div className="step">
                                <BankIcon />
                                <p>Verify your bank details</p>
                            </div>
                            <div className="step">
                                <UserIcon />
                                <p>Verify your personal details</p>
                            </div>
                            <div className="step">
                                <MoneyIcon />
                                <p>Get instant funds</p>
                            </div>
                        </div>
                    </div>
                    <div className='bottom-footer p-0'>
                        <p className='powered-by'>Powered by <StarfinLogo /></p>
                        <button className={`btn btn-primary ${isLoading ? 'disabled' : ''}`} onClick={() => {
                            //localStorage.setItem("lastVisitedPage", '/required-amount')
                            //navigate('/required-amount')
                            //window.location.href = redirectionLink
                            handleUnlockLocLimit()
                        }}>Continue</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreditApproval;
